webpackJsonp([196067925415476],{

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(487);
	
	var _aboutKris = __webpack_require__(653);
	
	var _aboutKris2 = _interopRequireDefault(_aboutKris);
	
	var _aboutKarol = __webpack_require__(652);
	
	var _aboutKarol2 = _interopRequireDefault(_aboutKarol);
	
	var _aboutKamil = __webpack_require__(651);
	
	var _aboutKamil2 = _interopRequireDefault(_aboutKamil);
	
	var _aboutMateusz = __webpack_require__(654);
	
	var _aboutMateusz2 = _interopRequireDefault(_aboutMateusz);
	
	var _aboutNoPhoto = __webpack_require__(62);
	
	var _aboutNoPhoto2 = _interopRequireDefault(_aboutNoPhoto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var members = [{
	  avatar: _aboutKris2.default,
	  name: 'Kris',
	  text: 'Właściciel i kierownik artystyczny. Od najmłodszych lat związany ze sceną zjadł zęby na eventach, co dało ogromne rozeznanie w potrzebach klienta. Dziś to właśnie dzięki jego charyzmie i doświadczeniu, ale przede wszystkim pozytywnemu nastawieniu agencja realizuje nietypowe, szyte na miarę zlecenia i cieszy się co raz większym zaufaniem klientów.'
	}, {
	  avatar: _aboutKarol2.default,
	  name: 'Karol',
	  text: '"Szara eminencja". Łącznik i "bezpiecznik" między artystami, a klientem. Koordynator, który z właściwym sobie poczuciem humoru, pilnuje by wszystko szło zgodnie z planem. Spotkasz go przy realizatorze albo w lewym sektorze garderoby, a prywatnie w 229 polskich kinach studyjnych i lokalnych.'
	}, {
	  avatar: _aboutKamil2.default,
	  name: 'Kamil',
	  text: 'Kiedy jest już wspaniała wizja i są najlepsi artyści, musi być doskonała technika, bo tylko zestawienie tych trzech czynników składa się na sukces. Kamil jak nikt inny dobiera sprzęt do potrzeb imprezy i odpowiada  za wszystko co gra, huczy i błyszczy.'
	}, {
	  avatar: _aboutMateusz2.default,
	  name: 'Mateusz',
	  text: 'Muzyka to nie tylko artysta, jego twórczość i wykonanie. Najpiękniejsze dźwięki nie zrobią na nikim wrażenia, jeśli nie będą dobrze nagłośnione. Mateusz to jeden z najlepszych w branży specjalistów od dźwięku, a do tego najbardziej pozytywna osoba jaką można sobie wyobrazić.'
	}];
	
	var Member = function Member(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'about-member' },
	    _react2.default.createElement(
	      'div',
	      { className: 'about-member__left' },
	      _react2.default.createElement('img', { src: '' + props.avatar, className: 'about-member__image', alt: props.name })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'about-member__right' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'about-member__title' },
	        props.name
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'about-member__content' },
	        props.text
	      )
	    )
	  );
	};
	
	var AboutMembers = function AboutMembers() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'about-members' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'about-members__list' },
	      members.map(function (member, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'about-members__element', key: index },
	          _react2.default.createElement(Member, { name: member.name, text: member.text, avatar: member.avatar })
	        );
	      })
	    )
	  );
	};
	
	exports.default = AboutMembers;
	module.exports = exports['default'];

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Client = function Client(_ref) {
	  var client = _ref.client;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'client' },
	    _react2.default.createElement('img', { className: 'client__logo', src: client.logo.resolutions.src, title: client.name, alt: client.name })
	  );
	};
	
	var Clients = function Clients(_ref2) {
	  var clients = _ref2.clients;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'clients' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'clients__list' },
	      clients.map(function (client, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'clients__element', key: index },
	          _react2.default.createElement(Client, { client: client })
	        );
	      })
	    )
	  );
	};
	
	exports.default = Clients;
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnSection = function ColumnSection() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'column-section__wrapper' },
	    _react2.default.createElement(
	      'section',
	      { className: 'column-section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column-section__left' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'column-section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'CustomArt'
	              ),
	              ' zrodzi\u0142a si\u0119 na scenie w \u015Bwietle reflektor\xF3w, a motorem nap\u0119dowym do jej powstania by\u0142a aktualnie flagowa formacja\xA0TheCustoms. Na przestrzeni lat nawi\u0105zali\u015Bmy wsp\xF3\u0142prac\u0119 z ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'ciekawymi artystami'
	              ),
	              ' oraz rozwin\u0119li\u015Bmy ofert\u0119 o szereg us\u0142ug dodatkowych dedykowanych dla bran\u017Cy eventowej.',
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' Nasze portfolio'
	              ),
	              ' to zar\xF3wno proste wydarzenia, skupione na zabawie przy d\u017Awi\u0119kach dobrej muzyki, jak i nietypowe zlecenia \u2013 wyst\u0119py na wysokich konstrukcjach, synchronizowanie d\u017Awi\u0119ku z efektami pirotechnicznymi i mappingami, czy kompleksowe tworzenie ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'autorskiej oprawy artystycznej'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Dzi\u0119ki rosn\u0105cemu zaufaniu klient\xF3w stale rozwijan\u0105 i kluczow\u0105 pozycj\u0105 w oferowanych us\u0142ugach s\u0105 w\u0142a\u015Bnie ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'rozwi\u0105zania customowe'
	              ),
	              ', czyli tworzone pod konkretne wydarzenie. Droga, kt\xF3r\u0105 przeszli\u015Bmy jest ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'wyj\u0105tkowa'
	              ),
	              ' i wierzymy, \u017Ce nie mog\u0142a zaprowadzi\u0107 nas gdzie indziej, dlatego staramy si\u0119 dba\u0107 o ka\u017Cdy detal naszych realizacji, osi\u0105gni\u0119t\u0105 pozycj\u0119 i stale si\u0119 rozwija\u0107. Dzi\u0119ki pasji, mi\u0142o\u015Bci do muzyki i sztuki oraz pozytywnemu nastawieniu spe\u0142niamy coraz odwa\u017Cniejsze ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'wizje klient\xF3w'
	              ),
	              ' i zdobywamy ich zaufanie. Aktualnie agencja oferuje szeroki wachlarz produkt\xF3w artystycznych, pe\u0142n\u0105 technik\u0119 estradow\u0105 oraz ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'rozwi\u0105zania szyte na miare'
	              ),
	              ' od kreacji artystycznej po realizacj\u0119 stworzonego show.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ColumnSection;
	module.exports = exports['default'];

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-kamil.f14a5362.jpg";

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-karol.b4549410.jpg";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-kris.6b9934fc.jpg";

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-mateusz.ae7a9c39.jpg";

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.75f26d0d.jpg";

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.0a52f5c6.jpg";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.b5e5f3bc.jpg";

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.f4999b48.jpg";

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5.7acd37e1.jpg";

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nasi-ludzie.87932cdc.jpg";

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Section = __webpack_require__(48);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ColumnSection = __webpack_require__(253);
	
	var _ColumnSection2 = _interopRequireDefault(_ColumnSection);
	
	var _Carousel = __webpack_require__(64);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Clients = __webpack_require__(90);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _AboutMembers = __webpack_require__(243);
	
	var _AboutMembers2 = _interopRequireDefault(_AboutMembers);
	
	var _Helmet = __webpack_require__(26);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _nasiLudzie = __webpack_require__(701);
	
	var _nasiLudzie2 = _interopRequireDefault(_nasiLudzie);
	
	var _onas = __webpack_require__(702);
	
	var _onas2 = _interopRequireDefault(_onas);
	
	var _ = __webpack_require__(655);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(656);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(657);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(658);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(659);
	
	var _10 = _interopRequireDefault(_9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = [{ resolutions: { src: _2.default } }, { resolutions: { src: _4.default } }, { resolutions: { src: _6.default } }, { resolutions: { src: _8.default } }];
	
	var seo = 'CustomArt to agencja artystyczna wyspecjalizowana w projektach nietypowych, ambitnych i takich, w których potrzeba niestandardowych rozwiązań na najwyższym poziomie.';
	
	var subtitle = "<p><strong>CustomArt to agencja artystyczna </strong>wyspecjalizowana w projektach nietypowych, ambitnych i takich, w których potrzeba niestandardowych rozwiązań na najwyższym poziomie.</p>";
	
	var About = function About(props) {
	  var clients = props.data.allContentfulClientList.edges[0].node.clients;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'app-about' },
	    _react2.default.createElement(
	      _Helmet2.default,
	      { title: 'O nas' },
	      _react2.default.createElement('meta', { name: 'description', content: seo })
	    ),
	    _react2.default.createElement(_Section2.default, {
	      isFirstSection: true,
	      title: 'O NAS',
	      background: _nasiLudzie2.default,
	      subtitle: subtitle
	    }),
	    _react2.default.createElement(_ColumnSection2.default, null),
	    _react2.default.createElement(
	      _Section2.default,
	      { title: 'NASI LUDZIE', background: _onas2.default },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__container', style: { padding: '100px 0' } },
	        _react2.default.createElement(_AboutMembers2.default, null)
	      )
	    ),
	    _react2.default.createElement(_Carousel2.default, { images: images }),
	    _react2.default.createElement(
	      'section',
	      { className: 'text-section', style: { padding: '100px 15px' } },
	      _react2.default.createElement(
	        'h2',
	        { className: 'text-section__title', style: { textAlign: 'center' } },
	        'Zuafali nam'
	      ),
	      _react2.default.createElement(_Clients2.default, { clients: clients })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center', padding: '30px 0' } },
	      _react2.default.createElement(_Button2.default, { type: 'yellow', label: 'Napisz do nas!', mailto: 'mailto:kontakt@customart.pl' })
	    ),
	    _react2.default.createElement('div', { style: { paddingTop: 100 } })
	  );
	};
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/onas.40d0fd19.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-o-nas-js-ce33215b8e42223faf2d.js